import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Confirmation.scss';

import axios from 'axios';
import confirmBookingImage from '../../../assets/images/booking-confirmed-tick.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import maleTravellerImage from '../../../containers/Passengers/img/adult-male.svg';
import femaleTravellerImage from '../../../containers/Passengers/img/adult-female.svg';
import maleChildTravellerImage from '../../../containers/Passengers/img/kid-male.svg';
import femaleChildTravellerImage from '../../../containers/Passengers/img/kid-female.svg';
import infantImage from '../../../containers/Passengers/img/infant.svg';

import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import Spinner from '../../UI/Spinner/Spinner';
import Loader from '../../UI/Loader/Loader';

import FlightInfoContainer from '../../Flight/Tuple/TupleInner/FlightInfo/FlightInfoContainer/FlightInfoContainer';
import FlightInfoBoxOuter from '../../Flight/Tuple/TupleInner/FlightInfo/FlightInfoBoxOuter/FlightInfoBoxOuter';
import FlightInfoBoxInnerLeft from '../../Flight/Tuple/TupleInner/FlightInfo/FlightInfoBoxInnerLeft/FlightInfoBoxInnerLeft';
import FlightInfoBoxInnerRight from '../../Flight/Tuple/TupleInner/FlightInfo/FlightInfoBoxInnerRight/FlightInfoBoxInnerRight';

import HeadingH4 from '../../UI/Headings/HeadingH4/HeadingH4';

import moment from 'moment';
import * as paymentActions from '../../../store/actions/index';

class Confirmation extends Component {
    state = {
        confirmationData: null
    }

    componentWillMount() {
        const ttid = sessionStorage.getItem("ttid");
        console.log(ttid);
        axios.get(`https://secure.yatra.com/air-pay-book-service/b2bdom/confirm/getResponseFromPaymentPortal?ttid=${ttid}&suc=true`)
            .then(response => {
                console.log("Reached inside response");
                console.log(response);
                console.log(response.data);
                console.log(JSON.parse(response.data));
                console.log(JSON.parse(response.data).data);
                const responseJSON = JSON.parse(response.data);
                this.setState({
                    confirmationData: responseJSON
                })
            })
            .catch(err => {
                console.log(err);
            });
    }

    render() {

        let cj = this.state.confirmationData;
        let bookingDate = null;
        let bookingDateUpdated = null;
        let paxJSX = null;
        let superPnr = null;
        let dDate = null;
        let departureMonthUpdated = null;
        let departureDayUpdated = null;
        let paxLength = 0;
        let flightPrice = 0;
        let bookingFee = 0;
        let pgSurcharge = 0;
        let cGST = 0;
        let sGST = 0;
        let totalAmount = 0;
        let youPaid = 0;
        let paymentMode = "";

        let title = 'Mr';
        let passengerClass = 'ADT';

        let flightSchedule = null;
        let confirmationData = (
            <div>
                <Spinner/>
                <Loader type='flight'/>
            </div>
        );

        if (cj) {
            for (let propName in cj.data.fltSchedule) {
                if (cj.data.fltSchedule.hasOwnProperty(propName)) {
                    flightSchedule = cj.data.fltSchedule[propName];
                }
            }
            bookingDate = cj.bookingDate;
            bookingDateUpdated = moment(bookingDate, 'DD-MM-YYYY').format('ddd DD MMM, YYYY');
            superPnr = cj.sc.payProp.superPnr;
            paxLength = cj.passengerList.length;
            flightPrice = cj.sc.charges.tfp;
            if(cj.sc.charges.wholeSalerFee) bookingFee = cj.sc.charges.wholeSalerFee;
            if(cj.sc.charges.pgSurcharge) pgSurcharge = cj.sc.charges.pgSurcharge;
            if(cj.sc.charges.wsfCgst) cGST = cj.sc.charges.wsfCgst;
            if(cj.sc.charges.wsfSgst) sGST = cj.sc.charges.wsfSgst;
            totalAmount = cj.sc.charges.total;
            youPaid = cj.sc.charges.amtPaid;
            paymentMode = cj.sc.payProp.mode;
            dDate = cj.departDate.split('-')[2];
            departureMonthUpdated = moment(cj.departDate, 'DD-MM-YYYY').format('MMM');
            departureDayUpdated = moment(cj.departDate, 'DD-MM-YYYY').format('ddd');
            paxJSX = (
                cj.passengerList.map((pax) => {
                    console.log(pax);
                        return (<li className={classes.Pax} key={pax.paxid}>
                        <div className={`u-flex justify-content-between`}>
                            <FontAwesomeIcon icon="check-circle" color="#0A9636" size="lg" />
                        </div>
                        <div className={`u-size80x80 u-borderRadius50 u-overflowHidden mx-auto`}>
                            <img className={`u-width100Percent u-height100Percent u-block`} src={
                                title === 'Mr' && passengerClass === 'ADT' 
                                ? maleTravellerImage : 
                                    title === 'Ms' && passengerClass === 'ADT' ? 
                                    femaleTravellerImage : 
                                        title === 'Mrs' && passengerClass === 'ADT' ?
                                        femaleTravellerImage :
                                            title === 'Miss' && passengerClass === 'CHD' ? 
                                            femaleChildTravellerImage :
                                                title === 'Master' && passengerClass === 'CHD' ? 
                                                maleChildTravellerImage :
                                                    passengerClass === 'INF' ?
                                                    infantImage : null } alt="Child" />
                        </div>
                        <div>
                            <h5 className={`u-fontSize13 u-fontWeightRegular u-textColorDark`}>{pax.title} {pax.fname} {pax.lname}</h5>
                            <h6 className={`u-fontSize13 u-fontWeightRegular u-textColorLight`}>{pax.paxClass.split(" ")[0]}</h6>
                        </div>
                    </li>
                )})
            );


            confirmationData = (
                <div className={`u-flex`}>
                <div className={`pl-10 pr-12 f-fill u-backgroundGrey`}>
                    <div className={`u-flex justify-content-between align-items-center pt-6 pb-8`}>
                        <div className={`u-flex align-items-center`}>
                            <div className={`mr-3 u-size120x120`}>
                                <img src={confirmBookingImage} alt="Booking Confirmed" className={`u-width100Percent`} />
                            </div>
                            <div>
                                <HeadingH2 size={26} weight="Medium" color="Dark">Congratulations!</HeadingH2>
                                <p className={`u-fontSize13 u-textColorNormal`}>Your flight booking has been confirmed.</p>
                            </div>
                        </div>
                        <div>
                            <div className={`mb-2 u-textAlignRight u-lineHeight1`}>
                                <p className={`u-textColorDark u-fontSize16`}>Web Check-in available on: <span className={`u-fontWeightMedium`}>25 Feb, 2018</span></p>
                            </div>
                            <div className={`u-textAlignRight u-lineHeight1`}>
                                <p className={`u-textColorNormal u-fontSize13`}>Booked on: {bookingDateUpdated}</p>
                            </div>
                        </div>
                    </div>
                    <div className={`u-flex justify-content-between mb-1`}>
                        <p className={`u-fontSize16 u-textColorDark`}>Booking Reference:&nbsp;<span className={`u-fontWeightMedium`}>{superPnr}</span></p>
                        <div className={`u-flex align-items-center`}>
                            <div>
                                    <span className={`mr-2`}><FontAwesomeIcon icon="print" color="#999" size="sm" /></span>
                                    <button className={`u-outline0 u-border0 u-textColorPrimary u-fontWeightMedium u-fontSize13 u-cursorPointer u-backgroundNone`}>Print</button>
                            </div>
                            <div className={`ml-6`}>
                                    <span className={`mr-2`}><FontAwesomeIcon icon="share-alt" color="#999" size="sm" /></span>
                                    <button className={`u-outline0 u-border0 u-textColorPrimary u-fontWeightMedium u-fontSize13 u-cursorPointer u-backgroundNone`}>Share</button>
                            </div>
                        </div>
                    </div>
                    <div className={`u-backgroundColorWhite mb-4`}>
                        {
                            flightSchedule[0].OD[0].FS.map((flight, index) => {
                                return <FlightInfoContainer key={index}>
                                    <FlightInfoBoxOuter>
                                        <FlightInfoBoxInnerLeft 
                                            airlineCode={flight.ac} 
                                            operatingAirline={flight.an} 
                                            flightNumberInitial={flight.ac} 
                                            flightNumberDigit={flight.fl}
                                            classType={flight.cabin}
                                            flightStatus={flight.ft === "Refundable" ? "1" : "0"} />
                                        <FlightInfoBoxInnerRight 
                                            departureTime={flight.dd}
                                            origin={flight.dac}
                                            originCity={flight.dct}
                                            dDate={dDate}
                                            departureMonthUpdated={departureMonthUpdated}
                                            departureDayUpdated={departureDayUpdated}
                                            originAirport={flight.dap}
                                            departureTerminal={flight.dt}
                                            durationTime={flight.du}
                                            destination={flight.aac}
                                            destinationCity={flight.act}
                                            arrivalTime={flight.ad}
                                            aDate={flight.adt.split('-')[2]}
                                            arrivalMonthUpdated={moment(flight.adt, 'DD-MM-YYYY').format('MMM')}
                                            arrivalDayUpdated={moment(flight.adt, 'DD-MM-YYYY').format('ddd')}
                                            destinationAirport={flight.aap}
                                            arrivalTerminal={flight.at}
                                            baggage={flight.bag}
                                            meal={"No Meal"}/>
                                        </FlightInfoBoxOuter>
                                    </FlightInfoContainer>;
                            })
                        }
                    </div>
                    <div className={`u-backgroundColorWhite pl-6 pr-6 pt-5 pb-5 mb-4`}>
                        <div className={`mb-6`}>
                            <HeadingH4 size={16} color="Dark" weight="Medium">Added Passengers</HeadingH4>
                            <p className={`u-fontSize13 u-textColorLight u-fontWeightRegular`}>You have added {paxLength} Passengers</p>
                        </div>
                        <div className={`mb-8`}>
                            <ul className={`u-flex`}>
                                { paxJSX }
                            </ul>
                        </div>
                        <div className={`mb-4`}>
                            <HeadingH4 size={16} color="Dark" weight="Medium">Userful Information &amp; Notes</HeadingH4>
                        </div>
                        <ul className={`u-fontSize13 u-textColorNormal u-fontWeightRegular`}>
                            <li className={`mb-4 u-flex`}><span className={`mr-3 u-textColorDark`}>&#9724;</span><span>Please carry a printout of your e-ticket along with a photo identity proof such as driving license, voter ID or passport etc issued by the Government of India. For infant passengers, it is mandatory to carry the Date of Birth certificate.</span></li>
                            <li className={`mb-4 u-flex`}><span className={`mr-3 u-textColorDark`}>&#9724;</span><span>Use your Airline PNR for all your communication of rthis booking with the Airline.</span></li>
                            <li className={`mb-4 u-flex`}><span className={`mr-3 u-textColorDark`}>&#9724;</span><span>All times indicated are in 24 hours format and we recommend that you check-in 2 hours prior to departure.</span></li>
                            <li className={`mb-4 u-flex`}><span className={`mr-3 u-textColorDark`}>&#9724;</span><span>Any change to a confirmed ticket - including cancellation or rescheduling- must be done at least 6 hours prior to flight departure. In case a passenger becomes a no show only the applicable taxes will be refunded to the passenger as per the airline policy.</span></li>
                            <li className={`mb-4 u-flex`}><span className={`mr-3 u-textColorDark`}>&#9724;</span><span>Please verify the addition of your flight service requests at the airport checkin counter.</span></li>
                        </ul>
                    </div>
                </div>
                <div style={{ flex: '0 0 35rem' }} className={`u-backgroundColorWhite u-boxShadowThin`}>
                    <div className={`p-6`}>
                        <HeadingH3 size={16} weight="Regular" color="Dark">Payment Summary</HeadingH3>
                        <p className="u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3">
                            <span>Flight Price</span> 
                            <span>&#8377;{Math.round(flightPrice).toLocaleString()}</span>
                        </p>
                        <p className="u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3">
                            <span>Payment Gateway Surchages</span> 
                            <span>&#8377;{Math.round(pgSurcharge).toLocaleString()}</span>
                        </p>
                        <p className="u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3">
                            <span>Booking Fee</span> 
                            <span>&#8377;{Math.round(bookingFee).toLocaleString()}</span>
                        </p>
                        <p className="u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3">
                            <span>cGST</span> 
                            <span>&#8377;{Math.round(cGST).toLocaleString()}</span>
                        </p>
                        <p className="u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3">
                            <span>sGST</span> 
                            <span>&#8377;{Math.round(sGST).toLocaleString()}</span>
                        </p>
                        <p className="u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3">
                            <span>Total Amount</span> 
                            <span>&#8377;{Math.round(totalAmount).toLocaleString()}</span>
                        </p>
                        <p className="u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark mb-3">
                            <span>You Paid</span> 
                            <span>&#8377;{Math.round(youPaid).toLocaleString()}</span>
                        </p>
                        <p className="u-flex justify-content-between align-items-center u-fontSize13 u-textColorDark">
                            <span>Payment Mode</span> 
                            <span>{paymentMode}</span>
                        </p>
                    </div>
                </div>
            </div>
            );
        }

        return confirmationData;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGetPaymentResponse: (paymentParams) => dispatch(paymentActions.getPaymentResponse(paymentParams, false))
    }
}

export default connect(null, mapDispatchToProps)(Confirmation);


// WEBPACK FOOTER //
// ./src/components/Payment/Confirmation/Confirmation.js